export const ToastKind = {
  SUCCESS: 'success',
  INFO: 'info',
  WARN: 'warn',
  ERROR: 'error',
} as const
export type ToastKinds = ValueOf<typeof ToastKind>

export type Toast = {
  kind: ToastKinds
  title: string
  description?: string
}

export const FrontErrorCodes = {
  STATE_INCONSISTENCY: 'STATE_INCONSISTENCY',
  UNKNOWN: 'UNKNOWN',
} as const
type FrontErrorCodes = typeof FrontErrorCodes

export type FrontErrorCode = FrontErrorCodes[keyof FrontErrorCodes]
